import React, { Component } from 'react';

class SearchInput extends Component {

    constructor(props){
        super(props);
        this.state = {
            interval: 0,
        }
    }

    handleChange(value){
        const self = this;

        if (self.state.interval) {
           clearTimeout(self.state.interval);
        }

        self.setState({
           typing: false,
           interval: setTimeout(function () {
               self.props.onChange(value);
           }, 250)
        });
    }

    render(){
        return(
            <div className="form-field">

                <input type="search" name={this.props.name} placeholder={this.props.placeholder} onKeyUp={(e)=>{this.handleChange(e.target.value)}} />

            </div>
        )
    }
}

// const SearchInput = (props) => {
//
//     return(
//         <div className="form-field">
//
//             <input type="search" name={props.name} placeholder={props.placeholder} onChange={props.onChange} />
//
//         </div>
//     )
// }
export default SearchInput;
